export const getIntentOrderId = (response: any): number => {
  const value =
    response?.body?.data?.orderId ??
    response?.payload?.body?.data?.orderId ??
    response?.body?.orderId ??
    response?.payload?.body?.orderId ??
    0;

  const orderId = Number(value);
  return Number.isSafeInteger(orderId) && orderId > 0 ? orderId : 0;
};

export const getPaymentFailureReason = (error: any): string => {
  const reason =
    error?.message ||
    error?.code ||
    (typeof error === "string" ? error : "Payment failed");

  return String(reason).replace(/[\r\n]/g, " ").trim().slice(0, 500);
};
